/**
 * "Previsão de volta" dos avisos de manutenção — formatação simples, sem
 * contagem regressiva ao vivo: é um dado informativo (tela de login, aviso
 * grande), não a experiência de quem já está logado esperando a volta.
 *
 * `null` quando não há previsão ou a data vier inválida — quem chama decide
 * se esconde a linha inteira (o rótulo "Previsão de volta:" nunca aparece
 * sem valor).
 *
 * Nasceu como função local de `pages/Login.tsx` (28/09/2026); movida para
 * cá para o `AvisoDeManutencaoNoLogin` e o Login usarem a MESMA conta.
 */
export function formatarPrevisaoDeVolta(estimatedEnd: string | null | undefined): string | null {
  if (!estimatedEnd) return null;
  const data = new Date(estimatedEnd);
  if (Number.isNaN(data.getTime())) return null;
  return data.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}
